<template>
  <div>
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <section class="flexbox-container">
          <div class="col-md-4 offset-md-4 col-xs-10 offset-xs-1 box-shadow-2 p-0">
            <div class="card border-grey border-lighten-3 px-2 py-2 m-0">
              <div class="card-header no-border pb-0">
                <div class="card-title text-xs-center">
                  <div class="p-0">
                    <img src="/static/app-assets/images/logo/logo_tr.png" alt="CITY GAS SERVICE" />
                  </div>
                </div>
                <h6 class="card-subtitle line-on-side text-muted text-xs-center font-small-3 pt-2">
                  <span>Восстановление пароля</span>
                </h6>
              </div>
              <div class="card-body collapse in">
                <div class="card-block">
                  <form class="form-horizontal form-simple" @submit.prevent="recover">
                    <p v-if="showError" class="text-xs-center text-danger">Неизвестный номер</p>
                    <fieldset class="form-group position-relative has-icon-left mb-1">
                      <input
                        type="text"
                        class="form-control form-control-lg input-lg"
                        id="mobile"
                        placeholder="Сотовый номер"
                        v-model="mobile"
                        required
                        pattern="^[+]?[0-9]{11}"
                        title="11 цифр без пробелов, с «+» в начале или без"
                      />
                      <div class="form-control-position">
                        <i class="icon-phone"></i>
                      </div>
                    </fieldset>
                    <button type="submit" name="submit" class="btn btn-primary btn-lg btn-block">
                      <i class="icon-unlock2"></i> Восстановить
                    </button>
                  </form>
                </div>
              </div>
              <div class="card-footer no-border">
                <p class="float-sm-left text-xs-center">
                  <router-link to="/login" class="card-link">Вход</router-link>
                </p>
                <p class="float-sm-right text-xs-center">
                  Новенькие?
                  <router-link to="/register" class="card-link">Регистрация</router-link>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { RECOVER_REQUEST } from "@/store/actions/auth";
export default {
  name: "Recover",
  data() {
    return {
      mobile: null,
      showError: false,
    };
  },
  methods: {
    recover: function () {
      this.$store
        .dispatch(RECOVER_REQUEST, { phone_number: this.mobile })
        .then(() => {
          this.$router.push("/login");
        })
        .catch(() => {
          this.showError = true;
        });
    },
  },
};
</script>